import { setMinutes, setHours, setDay, startOfWeek, endOfWeek, differenceInMilliseconds, differenceInSeconds, differenceInMinutes, startOfDay, getHours, getMinutes, setSeconds, getSeconds, setMilliseconds, getMilliseconds } from 'date-fns';
import { lte, add, min, max, inRange, eq, lt, gt } from 'date-arithmetic';

const manipulateDate = (day, hour, minute, weekStartsOn = 1) => setMinutes(setHours(setDay(new Date(), day, {
  weekStartsOn
}), hour), minute);
const getRange = (d, firstDayOfWeek) => {
  const firstOfWeek = firstDayOfWeek || 0;
  const start = startOfWeek(d, {
    weekStartsOn: firstOfWeek
  });
  const end = endOfWeek(d, {
    weekStartsOn: firstOfWeek
  });
  return range(start, end);
};
function range(start, end, unit = 'day') {
  let current = start;
  const days = [];
  while (lte(current, end, unit)) {
    days.push(current);
    current = add(current, 1, unit);
  }
  return days;
}
function diff(dateA, dateB, unit) {
  if (!unit) {
    return differenceInMilliseconds(dateB, dateA);
  }
  switch (unit) {
    case 'minutes':
      return differenceInMinutes(dateB, dateA);
    case 'seconds':
      return differenceInSeconds(dateB, dateA);
    default:
      return differenceInMilliseconds(dateB, dateA);
  }
}
function merge(date, time) {
  let timeClone = time;
  let dateClone = date;
  if (time == null && date == null) return null;
  if (time == null) timeClone = new Date();
  if (date == null) dateClone = new Date();
  dateClone = startOfDay(dateClone);
  dateClone = setHours(dateClone, getHours(timeClone));
  dateClone = setMinutes(dateClone, getMinutes(timeClone));
  dateClone = setSeconds(dateClone, getSeconds(timeClone));
  return setMilliseconds(dateClone, getMilliseconds(timeClone));
}
function getDayOfWeekFrom(date) {
  return date.getDay();
}

var dates = /*#__PURE__*/Object.freeze({
  __proto__: null,
  manipulateDate: manipulateDate,
  getRange: getRange,
  range: range,
  diff: diff,
  merge: merge,
  getDayOfWeekFrom: getDayOfWeekFrom,
  add: add,
  min: min,
  max: max,
  inRange: inRange,
  eq: eq,
  lt: lt,
  lte: lte,
  gt: gt
});

export { diff as a, manipulateDate as b, getDayOfWeekFrom as c, dates as d, getRange as g, merge as m, range as r };
